import {
  ATTENDANCE_STATUS,
  PURCHASE_SALES_PIE_CHART_DATAS,
  SALES_CHART_DATAS,
  BOND_DEBT_DATAS,
  DIVISION_LSIT,
  USER_LIST,

  GOURP_LSIT,
  GRADE_LSIT,
  SALES_CHART_DATAS2,
} from "../constants/FAKE_DATA";
import {
  getDay
} from "../utils/date";
import {
  getParams
} from "../utils/params";
import createError from "http-errors";
import {
  isObject
} from "lodash-es";

const customDatas = {
  purchaseSalesPieChartDatas: PURCHASE_SALES_PIE_CHART_DATAS,
  SALES_CHART_DATAS: SALES_CHART_DATAS,
  SALES_CHART_DATAS2: SALES_CHART_DATAS2,
  bondDebtDatas: BOND_DEBT_DATAS,
  ATTENDANCE_STATUS,
  DIVISION_LSIT,
  USER_LIST,
  GOURP_LSIT,
  GRADE_LSIT,
};

const total = 1211;
const delay = 1000 * 0.5;
// const delay = 1000 * 3;
const columnList = [
  "idx",
  "status",
  "taskType",
  "workSchedule",
  "partName",
  "number",
  "string",
  "content",
  "date",
  "title",
  "a",
  "b",
  "c",
  "d",
  "e",
  "user",
  "boolean",
];
const getRandom = () => {
  return Math.floor(Math.random() * 100);
};
const fakeDataList = (() => {
  const datas = [];
  for (let i = 0; i < total; i++) {
    const data = {};
    let ran = getRandom();
    columnList.forEach((column) => {
      switch (column) {
        case "workSchedule":
          data[column] = "9:00-18:00";
          break;
        case "partName":
          data[column] = "개발팀" + getRandom() + "";
          break;
        case "user":
          data[column] = {
            name: "홍길동"
          };
          break;
        case "taskType":
          ran = getRandom();
          if (ran > 66) data[column] = "휴가신청";
          else if (ran > 33) data[column] = "연장근무 신청";
          else data[column] = "경비청구";
          break;
        case "status":
          ran = getRandom();
          if (ran > 66) data[column] = "wait";
          else if (ran > 33) data[column] = "procee";
          else data[column] = "complete";
          break;
        case "number":
          data[column] = getRandom() * getRandom() * getRandom();
          break;
        case "title":
          data[column] =
            "타이틀입니다." + getRandom() * getRandom() * getRandom() + "";
          break;
        case "string":
        case "content":
          data[column] =
            "내용입니다. " + getRandom() * getRandom() * getRandom() + "";
          break;
        case "date":
          data[column] = getDay(getRandom());
          break;
        case "boolean":
          data[column] = getRandom() % 2 === 0 ? true : false;
          break;
        case "idx":
          data[column] = i;
          break;
        default:
          data[column] = `${column}${i}`;
          break;
      }
    });
    datas.push(data);
  }
  return datas;
})();

export const getFakeDataList = (
  params = {
    offset: 0,
    limit: 15
  },
  _delay = delay,
  error = false
) => {
  const {
    offset,
    limit,
    status
  } = params;
  console.log("[fakeapi] params: ", params);
  return new Promise((resolve, reject) => {
    let datas = fakeDataList;
    const metadata = getParams({
      offset,
      limit,
      search: "status",
      searchText: status,
    });
    if (status) datas = fakeDataList.filter((data) => data.status === status);
    const _total = datas.length;
    datas = datas.slice(offset, offset + limit);
    setTimeout(() => {
      if (error) {
        if (isObject(error)) {
          reject(
            createError(error.status || 400, error.message || "테스트에러")
          );
        } else {
          reject(createError(400, `${error}`));
        }
      } else {
        resolve({
          metadata,
          total: _total,
          ...customDatas,
          datas,
        });
      }
    }, _delay);
  });
};